export const StorageKeys = {
	SLD: 'SLD',
	USER: 'USER',
	CART: 'CART',
	ORDER_DETAILS: 'ORDER_DETAILS',
};

export type StorageKeys = (typeof StorageKeys)[keyof typeof StorageKeys];
